module.exports = __webpack_public_path__ + "static/media/Stack360.45c89f44.png";